import { render, staticRenderFns } from "./CharacterEditPage.vue?vue&type=template&id=6c3350ce&scoped=true"
import script from "./CharacterEditPage.vue?vue&type=script&lang=ts"
export * from "./CharacterEditPage.vue?vue&type=script&lang=ts"
import style0 from "./CharacterEditPage.vue?vue&type=style&index=0&id=6c3350ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3350ce",
  null
  
)

export default component.exports